import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect'
import apiConfig from '../axiosConfig';

export const fetchCategory = createAsyncThunk('giftCategoryManagement/fetchAssets', async () => {
	const response = await apiConfig.get('category-management/list');
	return response.data;
});

export const toggelDeleteGiftCategory = createAsyncThunk(
	'giftCategoryManagement/toggelDelete',
	async (wrapperId) => {
		const response = await apiConfig.delete(`category-management/delete/${wrapperId}`);
		const data = await response.data;
		return data;
	}
);

export const addNewCategory = createAsyncThunk(
	'giftCategoryManagement/addNewCategory',
	async (rec_data) => {
		const formData = new FormData();
		console.log('before send', rec_data);
		if (rec_data.image != null) {
			formData.append('file', rec_data.image, rec_data.image.name);
			const response = await apiConfig.post(`category-management/upload`, formData);
			const data = await response.data.data;
			rec_data.CategoryData.imageUrl = data.csImageUlr;
			rec_data.CategoryData.imageUrlGcp = data.gcpImageUrl;
		}
		console.log('after update:', rec_data.CategoryData);
		console.log('mood:', rec_data.isUpdate);
		if (!rec_data.isUpdate) {
			const responseWrapper = await apiConfig.post(
				`category-management/add`,
				rec_data.CategoryData
			);
			return responseWrapper;
		} else {
			console.log('mood update:', rec_data.isUpdate);

			// update action
			const responseWrapper = await apiConfig.put(
				`category-management/update/${rec_data.CategoryData.id}`,
				rec_data.CategoryData
			);
			return responseWrapper;
		}
	}
);
const giftCategoryManagementSlice = createSlice({
	name: 'giftCategoryManagement',
	initialState: {
		assets: [],
		status: null,
		error: null,
	},
	reducers: {},
	extraReducers: {
		[fetchCategory.pending]: (state) => {
			console.log('Pending');
			state.status = 'loading';
		},
		[fetchCategory.fulfilled]: (state, action) => {
			const response = action.payload;
			if (response && response.status === 'OK') {
				state.status = 'OK';
				state.assets = response.data;
			} else {
				state.status = 'failed';
				//state.error = action.error.message;
			}
		},
		[fetchCategory.rejected]: (state, action) => {
			state.status = 'failed';
			state.error = action.error.message;
		},
		[toggelDeleteGiftCategory.fulfilled]: (state, action) => {
			const response = action.payload;

			if (response.status === 'OK') {
				const itemIndex = state.assets.findIndex(
					(item) => item.id === action.payload.data.id
				);
				state.assets[itemIndex] = action.payload.data;
			} else {
				state.status = 'failed';
				state.error = action.error.message;
			}
		},
		[addNewCategory.fulfilled]: (state, action) => {
			const response = action.payload.data;

			if (response.status === 'OK') {
				const itemIndex = state.assets.findIndex(
					(item) => item.id === action.payload.data.data.id
				);
				if (itemIndex === -1) {
					state.assets = [...state.assets, action.payload.data.data];
				} else {
					state.assets[itemIndex] = action.payload.data.data;
				}
			} else {
				state.status = 'failed';
				state.error = action.error.message;
			}
		},
	},
});

export const selectCategoryByCountry = (state, countryCode) => [
	{ id: 'all', title: 'All' },
	...state.giftCategoryList.assets.filter((category) => category.country === countryCode),
];

export const selectMemoCategoryByCountry = createSelector(
  [
		(state) => state.giftCategoryList.assets,
		(state, countryCode) => countryCode,
	],
  (categories, countryCode) => ([
		{ id: 'all', title: 'All' },
		...categories.filter((category) => category.country === countryCode)
	]),
)

export const assetManagementActions = giftCategoryManagementSlice.actions;
export default giftCategoryManagementSlice.reducer;
